import { NoddiAsyncError, OwnStorageFacility, SALES_ITEM_BOOKING_FLOW_TYPE, SelectedSalesItemsCar } from 'noddi-types';

const OWN_STORAGE_FACILITY_CODE = 'wheel_pickup_address_is_own_storage_facility';

/**
 * Our facilities at the typed pickup address when booking creation failed with
 * wheel_pickup_address_is_own_storage_facility, else empty. Read from the untyped error_context envelope (snake_case),
 * so malformed entries are dropped.
 */
export const getOwnStorageFacilities = (error: NoddiAsyncError | null): OwnStorageFacility[] => {
  const data = error?.response?.data;
  if (!data?.errors?.some(({ code }) => code === OWN_STORAGE_FACILITY_CODE)) {
    return [];
  }
  const facilities: unknown = data.error_context?.storage_facilities;
  if (!Array.isArray(facilities)) {
    return [];
  }
  return facilities.flatMap((facility) => {
    if (typeof facility !== 'object' || facility === null) {
      return [];
    }
    const { storage_facility_id, name, address } = facility as Record<string, unknown>;
    if (typeof storage_facility_id !== 'number' || typeof name !== 'string') {
      return [];
    }
    return [{ storageFacilityId: storage_facility_id, name, address: typeof address === 'string' ? address : '' }];
  });
};

/** Preserve other cars' choices when correcting the rejected pickup address. */
export const getOwnStorageFacilityPickups = (
  selectedSalesItemsCars: SelectedSalesItemsCar[],
  error: NoddiAsyncError | null
): SelectedSalesItemsCar[] => {
  if (getOwnStorageFacilities(error).length === 0) {
    return [];
  }
  const addressId: unknown = error?.response?.data.error_context?.pickup_address_id;
  if (typeof addressId !== 'number') {
    return [];
  }
  return selectedSalesItemsCars.filter(
    (item) =>
      item.type === SALES_ITEM_BOOKING_FLOW_TYPE.TIRE_HOTEL_PICKUP &&
      (item.metaData?.selectedTireHotelPickUpAddress?.id ?? item.metaData?.selectedTireHotelLocation?.address.id) ===
        addressId
  );
};
